export const iconFontAwesomeUsersPeopleHeadSideMask = (
	<i className="fa-solid fa-head-side-mask"></i>
);
